import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { StyledMarker } from './forecastTypeSelectorConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ForecastManualSubmissionConfig = {
  id: 'forecast-manual-submission-coaching-tips',
  tips: [{
    attachTo: '[data-coaching-tip="forecast-submission-deal-selector"]',
    placement: 'bottom left',
    popoverPlacement: 'right',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "forecastingCoachingTips.manualSubmissions.dealTable.title"
    }),
    steps: [{
      content: /*#__PURE__*/_jsxs(View, {
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "forecastingCoachingTips.manualSubmissions.dealTable.body"
        }), /*#__PURE__*/_jsx(StyledMarker, {})]
      })
    }]
  }]
};
export default ForecastManualSubmissionConfig;